

import Dummy from "components/Dummy";
import ExhibitionCard from "../card/ExhibitionCard";
import ExhibitionPackageCard from "../card/ExhibitionPackageCard";
import { useEffect, useState } from "react";
import { requester } from "App";
import { useParams } from "react-router-dom";
import ExhibitionMiddlePackageCard from "../card/ExhibitionMiddlePackageCard";


function ExhibitionView(props) {
    const { setViewData } = props;
    const { id } = useParams();
    const [exhibitionproducts, setExhibitionProducts] = useState([]);
    useEffect(() => {
        let data = {
            storeCode: id
        }
        requester.findAllExhibitionsForStore(data, (result) => {
            setExhibitionProducts(result.data)
        })
    }, [])


    return (
        <div style={{ width: "100%", height: "100%", position: "relative", justifyContent: "center", display: "flex", alignItems: "center" }}>
            <div style={{ gap: "5px", flexDirection: "row", flexWrap: "wrap", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "wrap" }}>
                {
                    exhibitionproducts
                        .sort((a, b) => {
                            if (b.products.length === 4) return 1; 
                            return -1;
                        })
                        .map((row, index) => (
                            row.products.length === 2
                                ? <ExhibitionCard setViewData={setViewData} data={row} key={index} filter={'exhibition'} />
                                : row.products.length === 3
                                    ? <ExhibitionMiddlePackageCard setViewData={setViewData} data={row} key={index} filter={'exhibition'}/>
                                    : <ExhibitionPackageCard setViewData={setViewData} data={row} key={index} filter={'exhibition'} />
                        ))
                }
                <Dummy height={"10px"} />
            </div>
        </div>
    );
}

export default ExhibitionView;